import { useSelector } from "react-redux";
import { getSpecificGeneralInfo } from "@/store/slices/general/generalSlice";
import LogoIcon from "@/public/assets/app-images/blazeo_actual.png";
import WhiteLogoIcon from "@/public/assets/app-images/blazeo-white-logo.png";
import { ThemePalettes } from "@/services/theme-palettes";
import tinycolor from "tinycolor2";
import { cloneDeep } from "@/services/generic.methods";

const useCRMTheme = (isPublic = false) => {
  const themeInfo = useSelector(getSpecificGeneralInfo("theme"));

  let navbarLogo =
    themeInfo?.mode === "light_theme" || isPublic
      ? LogoIcon.src
      : WhiteLogoIcon.src;

  let selectedTheme = cloneDeep(ThemePalettes[themeInfo?.mode]);

  const changeThemeColor = (colorInfo = themeInfo) => {
    const {
      selectedPrimary,
      selectedSecondary,
      customPrimary,
      customSecondary,
    } = colorInfo;
    let primaryColor = "";
    let secondaryColor = "";
    if (selectedPrimary?.includes("_2")) {
      primaryColor = customPrimary?.color;
    }
    if (selectedSecondary?.includes("_2")) {
      secondaryColor = customSecondary?.color;
    }

    if (primaryColor) {
      selectedTheme.custom.primary_button = primaryColor;
      selectedTheme.custom.primary_button_text = getTextColor(primaryColor);
    } else {
      selectedTheme.custom.primary_button = "var(--palette-primary_main)";
      selectedTheme.custom.primary_button_text =
        "var(--palette-primary_button_text_default)";
    }

    if (secondaryColor) {
      selectedTheme.custom.secondary_button = secondaryColor;
      selectedTheme.custom.secondary_button_text = getTextColor(secondaryColor);
    } else {
      selectedTheme.custom.secondary_button = "var(--palette-secondary_main)";
      selectedTheme.custom.secondary_button_text =
        "var(--palette-secondary_button_text_default)";
    }
  };

  // changeThemeColor();

  return { themeInfo, navbarLogo, selectedTheme, changeThemeColor };
};

export default useCRMTheme;

const getTextColor = (bgColor) => {
  return tinycolor(bgColor).isLight() ? "#000000" : "#FFFFFF";
};
